import { useEffect, useState } from "react";
import { useDialog } from "../libs/dialog/DialogProvider";
import LoginDialog from "./Login/LoginDialog"
import PortAccount from "../models/PortAccount";

export default function useLogin(){
    const {openDialog,closeDialog} = useDialog();
    const [ready,setReady] = useState<boolean>(false)
    const account = PortAccount.i

    const onAuth = (authenticated:boolean) => {
      if (!authenticated) openDialog({id:"login", canClose:()=>false,children:<LoginDialog onLoggedIn={closeDialog}/>})
      setReady(authenticated)
    }
    useEffect(() => {
      account.on("auth", onAuth).auth()
      return () => {
        account.removeListener("auth", onAuth)
      }
    }, [])
    return {account,ready}
}
